import { render, staticRenderFns } from "./UnFrame.vue?vue&type=template&id=22b48720&scoped=true"
import script from "./UnFrame.vue?vue&type=script&lang=ts"
export * from "./UnFrame.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b48720",
  null
  
)

export default component.exports